var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { alpha } from '@mui/material/styles';
import { toggleButtonClasses } from '@mui/material/ToggleButton';
// ----------------------------------------------------------------------
var COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];
// ----------------------------------------------------------------------
export function toggleButton(theme) {
    var _a;
    var rootStyles = function (ownerState) {
        var _a, _b, _c;
        var defaultStyle = (_a = {},
            _a["&.".concat(toggleButtonClasses.selected)] = {
                borderColor: 'currentColor',
                // boxShadow: '0 0 0 0.5px currentColor',
                backgroundColor: '#009983',
                color: 'white'
            },
            _a);
        var colorStyle = COLORS.map(function (color) { return (__assign({}, (ownerState.color === color && {
            '&:hover': {
                borderColor: alpha(theme.palette[color].main, 0.48),
                backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity)
            }
        }))); });
        var disabledState = (_b = {},
            _b["&.".concat(toggleButtonClasses.disabled)] = (_c = {
                    borderColor: theme.palette.action.disabledBackground
                },
                _c["&.".concat(toggleButtonClasses.selected)] = {
                    borderColor: theme.palette.action.disabledBackground
                },
                _c),
            _b);
        return __spreadArray(__spreadArray([defaultStyle], __read(colorStyle), false), [disabledState], false);
    };
    return {
        MuiToggleButton: {
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return rootStyles(ownerState);
                }
            }
        },
        MuiToggleButtonGroup: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    backgroundColor: '#00937E14',
                    border: "solid 1px transparent",
                    color: '#006F5F'
                },
                grouped: (_a = {
                        margin: 0
                    },
                    _a["&.".concat(toggleButtonClasses.selected)] = {
                        boxShadow: 'none',
                        backgroundColor: '#009983',
                        color: 'white',
                        border: 'none'
                    },
                    _a['&:not(:first-of-type):not(:last-of-type)'] = {
                        borderColor: 'transparent'
                    },
                    _a['&:last-of-type:not(.Mui-selected)'] = {},
                    _a['&:first-of-type:not(.Mui-selected)'] = {
                        border: 'none !important'
                    },
                    _a['&:nth-of-type(n+2):not(.Mui-selected)'] = {
                        border: 'none !important'
                    },
                    _a)
            }
        }
    };
}
